import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-sale',
    styleUrl: './sale.component.scss',
    templateUrl: './sale.component.html',
})
export class SaleComponent {
    //
}
